export enum SkuWidgetComponentIds {
  Value = '#skuValue',
  Label = '#skuLabel',
  TopContainer = '#skuBox',
  BoxContainer = '#box1',
}
